"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExtensionTabs = void 0;
exports.ExtensionTabs = new (class {
    async sendMessage(tabId, type, payload) {
        window.postMessage({
            type,
            payload,
        });
        return null;
    }
})();
